import RmSlider from '../../vendor/rm-slider'

function resetSearch() {
    $('.blogPage-filterReset').on('click', function() {
        $('#s').val('')
        $('#blog-searchForm').trigger('submit')
        $('.blogPage-filterReset').removeClass('active')
    })
}

function toogleClassResetBtn() {
    $('#s').on('keyup', function() {
        if ($(this).val() !== '') {
            $('.blogPage-filterReset').addClass('active')
        } else {
            $('.blogPage-filterReset').removeClass('active')
        }
    })
}

function toggleFilterArchive() {
    $('.filter-button').on('click', function () {
        if (!$(this).parent('.blogPage-filterType').hasClass('filterOpen')) {
            $('.blogPage-filterType.filterOpen').find('.filter-dropdownContainer').css('height', '0px')
            $('.blogPage-filterType.filterOpen').removeClass('filterOpen')
        }

        const $parent = $(this).parent('.blogPage-filterType')
        $parent.toggleClass('filterOpen')

        if ($parent.hasClass('filterOpen')) {
            const height = $(this).next('.filter-dropdownContainer').find('.filter-dropdown').outerHeight()
            $(this).next('.filter-dropdownContainer').css('height', `${height}px`)
        } else {
            $(this).next('.filter-dropdownContainer').css('height', '0px')
        }
    })
}




function ajaxRequest({
    filterTheme,
    search,
    order = 'DESC'
}) {
    $.post({
        url: '/wp-admin/admin-ajax.php',
        dataType : "html",
        data: {
            action: 'filter_search_post',
            filterTheme,
            order,
            search
        },
        success: function (response) {
            $('.blogPage-archivePost article, .blogPage-archivePost .blogPage-noArticle').fadeOut(100, function() {
                $(this).remove()
            })

            $(response).appendTo('.blogPage-archivePost').fadeIn(100, function() {
                $('.blogPage-archivePost').find('.loader').fadeOut(200, function() {
                    $(this).remove()
                });
            })
        },
        beforeSend: function(){
            $('.blogPage-archivePost').append('<div class="loader"><div class="loader-spinner"><div></div>')
        }
    });
}


function filterArchive() {
    $('.filter-dropdown li').on('click', function() {
        $(this).parents('.filter-dropdownContainer').css('height', '0px')
        $(this).parents('.blogPage-filterType').removeClass('filterOpen')

        $(this).parent().find('.selected').removeClass('selected')
        $(this).addClass('selected')
        $(this).parents('.blogPage-filterType').find('.filter-button span:last-child').text($(this).text())

        const filterTheme = $('[data-filtername="theme"]').find('.selected').data('filter') ?? null
        const order = $('[data-filtername="order"]').find('.selected').data('filter')
        const search = $('#s').val() ?? null

        ajaxRequest({
            filterTheme,
            order,
            search
        })


    })

    $('#s').on('keydown', function(event){
        if(event.keyCode == 13) {
          event.preventDefault();
          $('#blog-searchForm').trigger('submit')
        }
      });
}

function searchPost() {
    $('#blog-searchForm').on('submit', function(event) {
        event.preventDefault()

        const search = $('#s').val()

        ajaxRequest({
            search
        })
    })
 

}

function slider() {
    if ($('.blogPage-sliderItem').length > 1) {
        const rmSlider = new RmSlider($('.blogPage'))
        rmSlider.init()
    }
}

function moreVideo() {
    $('.video_more .cta').on('click', function () {
        $(this).parent().css('display','none');
        $(this).parents('.capsulevideo-list').find(".autre_video").addClass('show_video');
        return false;
    })
}

export default {
    init() {
        resetSearch()
        toogleClassResetBtn()
        toggleFilterArchive()
        filterArchive()
        searchPost()
        slider()
        moreVideo()
    },
}